// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 614 ? "audio-worker" : chunkId) + "." + {"510":"02a8da05","614":"d1bb1bcf"}[chunkId] + ".chunk.js";
};